import React, { memo } from 'react';
import styles from './index.module.scss';
import { ParallaxBlock } from '../../ui/ParallaxBlock';
import { Bubble } from '../../ui/Bubble';
import { BUBBLE_TEXTS } from '../../../data';

export const NutritionSection = memo(function NutritionSection() {
  return (
    <ParallaxBlock className={styles.root}>
      <div className={styles.image__left} />
      <div className={styles.image__right} />
      <Bubble
        classNameRoot={styles.bubbleRoot}
        classNameBubble={styles.bubble}
        color="yellow"
        shape="egg"
        text={BUBBLE_TEXTS.nutrition}
      />
    </ParallaxBlock>
  );
});
